import { render } from "./ProductItem.vue?vue&type=template&id=487e169a&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=js"
export * from "./ProductItem.vue?vue&type=script&lang=js"

import "./ProductItem.vue?vue&type=style&index=0&id=487e169a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487e169a"]])

export default __exports__